export default "__VITE_ASSET__DVMUduN6__"